import { ItemList } from 'data/nav.data';

import * as S from './SubList.styles';

type SubListProps = {
  items: ItemList[];
};

export function SubList(props: SubListProps): React.ReactElement {
  const { items } = { ...props };

  const listItemsMapped = items?.map((item: ItemList) => (
    <S.ListItem key={item.id}>
      <S.ListButton scale="xs" motive="navSubItem" asLink to={item.to} end={item.end}>
        {item.name}
      </S.ListButton>
    </S.ListItem>
  ));

  return <S.List>{listItemsMapped}</S.List>;
}
